import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminContent from './Content';
import DeleteModalForm from 'src/components/Items/DeleteModalForm';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import AdminFilter from './Filter';

const AdminPage: FC = () => {
  const navigate = useNavigate();
  const { role } = useTypedSelector(state => state.auth);
  const [tab, setTab] = useState(0);
  const [openEl, setOpenEl] = useState([false, false, false, false]);
  const [openDelAll, setOpenDelAll] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [SPforDelete, setSPforDelete] = useState<number[]>([]);
  const [searchByLocation, setSearchByLocation] = useState('');

  useEffect(() => {
    if (role !== 'admin') navigate('/');
  }, [role]);

  const handleChangeModal = (isOpen: boolean) => {
    const elements = [...openEl];
    elements[tab] = isOpen;
    setOpenEl(elements);
  };

  return (
    <>
      <AdminFilter
        tab={tab}
        setTab={setTab}
        openDelAll={openDelAll}
        setOpenDelAll={setOpenDelAll}
        SPforDelete={SPforDelete}
        setSPforDelete={setSPforDelete}
        setOpenModal={setOpenModal}
        setSearchByLocation={setSearchByLocation}
        handleChangeModal={handleChangeModal}
      />
      <AdminContent
        tab={tab}
        search={searchByLocation}
        isDeleteSP={openDelAll}
        SPforDelete={SPforDelete}
        setSPforDelete={setSPforDelete}
        open={openEl}
        handleClose={() => handleChangeModal(false)}
      />
      <DeleteModalForm
        id={SPforDelete}
        type='season price'
        handleClose={() => setOpenModal(false)}
        open={openModal}
      />
    </>
  );
};
export default AdminPage;
